import femaleimage1 from './female/image1Full.svg'
import femaleimage2 from './female/image2Full.svg'
import femaleimage3 from './female/image3Full.svg'
import femaleimage4 from './female/image4Full.svg'
import femaleimage5 from './female/image5Full.svg'
import femaleimage6 from './female/image6Full.svg'

import maleimage1 from './male/image1Full.svg'
import maleimage2 from './male/image2Full.svg'
import maleimage3 from './male/image3Full.svg'
import maleimage4 from './male/image4Full.svg'
import maleimage5 from './male/image5Full.svg'
import maleimage6 from './male/image6Full.svg'

const images = {
	male: [
		maleimage1,
		maleimage2,
		maleimage3,
		maleimage4,
		maleimage5,
		maleimage6,
	],
	female: [
		femaleimage1,
		femaleimage2,
		femaleimage3,
		femaleimage4,
		femaleimage5,
		femaleimage6,
	],
}

export default images
